import React from "react";
import { CarOutlined } from "@ant-design/icons";
import { Tooltip, Tag } from "antd";
const VehicleDamagedTag = ({ bold }) => (React.createElement(Tooltip, { color: "#fff", title: "A shipment with a vehicle which has been damaged while in transit." },
    React.createElement(Tag, { color: "error", style: { fontWeight: bold ? "bold" : "normal" } },
        React.createElement(CarOutlined, null),
        " Vehicle Damaged")));
VehicleDamagedTag.defaultProps = {
    bold: false,
};
export default VehicleDamagedTag;
